module.exports = "data:image/webp;base64,UklGRpIAAABXRUJQVlA4IIYAAADQBACdASoZABkAPpFAm0qlo6IhqAgAsBIJZxLgAo+QL3MCuLiutyIj5Ne3MLtwAAD+672qDNM56KVdHuJUGs1PQQ0bFrq4/14jDRpsnel5+JjvhfG/IU4yZo7cpzlxXYW7b10Dk0qLXo6HjHRd7U6CAz+p0D85wqfuZGBwpdlovWbmpAAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/Vanilla_Heat.webp
// module id = kg5a
// module chunks = 14